/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Export_Change_FileInputs */

const cs_social_export_change_file = /** @type {(inputs: Social_Export_Change_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vybrat jiný soubor`)
};

const en_social_export_change_file = /** @type {(inputs: Social_Export_Change_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose another file`)
};

/**
* | output |
* | --- |
* | "Choose another file" |
*
* @param {Social_Export_Change_FileInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_export_change_file = /** @type {((inputs?: Social_Export_Change_FileInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Export_Change_FileInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_export_change_file(inputs)
	return cs_social_export_change_file(inputs)
});